import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { stripLangPrefix, SUPPORTED_LANGS } from '@/hooks/useLocalizedPath';
import type { Language } from '@/i18n/translations';
import { getDefaultLocalizedPath, getLocalizedPathForLang } from '@/data/legalNav';

const BASE_URL = 'https://www.taxisalzburg.net';

const HreflangTags = () => {
  const { pathname } = useLocation();
  const cleanPath = stripLangPrefix(pathname);

  return (
    <Helmet>
      {SUPPORTED_LANGS.map((lang) => (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang}
          href={`${BASE_URL}${getLocalizedPathForLang(pathname, lang as Language)}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${BASE_URL}${getDefaultLocalizedPath(pathname)}`}
      />
    </Helmet>
  );
};

export default HreflangTags;
